export default __webpack_public_path__ + "static/share-b812d3ab6a5b72dab1f8f199bf819c1f.jpg";